import React from 'react';
import PropTypes from 'prop-types';

import { COLORFUL_OPTION_HEX } from '@common/constants/colors';

import { SolidColorIcon, ColorfulIcon } from './ColorIcon.styled';

export const ColorIcon = ({ customAs, color, className }) => {
  if (color.toLowerCase() === COLORFUL_OPTION_HEX) {
    return <ColorfulIcon />;
  }

  return <SolidColorIcon as={customAs} className={className} $color={color} />;
};

ColorIcon.propTypes = {
  customAs: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
};

ColorIcon.defaultProps = {
  customAs: undefined,
  color: 'bluegrey.90',
  className: undefined,
};

export default ColorIcon;
